export const CANCELLATION_OFFER_LIST = 'cancellation-offer-list'
export const PAYTM_CITIES_DATA = 'cancellation-paytm-cities-data'
export const CLEAR_CANCELLATION_OFFER_DATA = 'clear-cancellation-offer-data'
export const ROUTE_SERVICES = 'cancellation-offer-route-services'
export const OFFER_DATA = 'cancellation-offer-data'
